import { AttachmentType, AttachmentTypeDescription } from 'src/app/interfaces/attachment-type'

const AttachmentTypeDatas = {
  SECURE: {
    text: '안정형',
    icon: 'assets/fontawesome/face-grin-wide.svg',
    dotEmoji: 'assets/icons/attachment/emoji-secure.png',
    color: '#006962',
    // -4 to 4
    graphImage: 'assets/icons/attachment/graph-secure.png',
    // 0 to 10
    graphImage0to10: 'assets/icons/attachment/graph-secure-0to10.png',
  },
  AVOIDANT: {
    text: '회피형',
    icon: 'assets/fontawesome/face-clouds.svg',
    dotEmoji: 'assets/icons/attachment/emoji-avoidant.png',
    color: '#0059BF',
    graphImage: 'assets/icons/attachment/graph-avoidant.png',
    graphImage0to10: 'assets/icons/attachment/graph-avoidant-0to10.png',
  },
  ANXIOUS: {
    text: '불안형',
    icon: 'assets/fontawesome/face-anguished.svg',
    dotEmoji: 'assets/icons/attachment/emoji-anxious.png',
    color: '#F35937',
    graphImage: 'assets/icons/attachment/graph-anxious.png',
    graphImage0to10: 'assets/icons/attachment/graph-anxious-0to10.png',
  },
  DISORGANIZED: {
    text: '혼란형',
    icon: 'assets/fontawesome/face-spiral-eyes.svg',
    dotEmoji: 'assets/icons/attachment/emoji-disorganized.png',
    color: '#9D389F',
    graphImage: 'assets/icons/attachment/graph-disorganized.png',
    graphImage0to10: 'assets/icons/attachment/graph-disorganized-0to10.png',
  },
}

const AttachmentTypeDescriptions: { [key: string]: AttachmentTypeDescription } = {
  SECURE: {
    general: [
      '상대방과 가까워지고 친밀감을 교류하는데 불편함이나 어려움을 느끼지 않습니다.',
      '밀당을 불필요한 것이라 느끼고, 본인의 감정을 솔직하게 표현하려 노력합니다.',
      '관계가 더 나아질 것이라는 믿음을 가지며, 상대방의 행복에 대한 책임감을 느끼기도 합니다.',
      '갈등이 있을 때 상대방에게 상처를 주기보다, 문제 해결에 집중하며 효과적으로 소통하곤 합니다.',
    ],
  },
  AVOIDANT: {
    general: [
      '사생활과 독립성을 매우 중시하며, 독립적인 자신을 자랑스러워 하기도 합니다.',
      '상처를 주거나 받지 않기 위해, 서로 의지하는 상황을 되도록 만들지 않으려고 합니다.',
      '감정 표현이나 속 이야기를 하기를 꺼리는 편입니다.또는 자기만의 비밀스러운 영역을 남겨두기도 합니다.',
      '안전한 거리가 유지될 때(썸, 이별 후 등) 마음이 편안하고, 가까워지면 밀어내고 싶은 욕구가 높아집니다.',
    ],
    advice: [
      '본인의 회피 성향을 자각하는 것이 필요합니다. 정말로 상대방이 싫어진 것인지, 단순히 거리를 두고 싶어진 것인지 잘 돌아보세요.',
      '사람이라면 누구나 친밀감이 필요합니다. 믿을 수 있는 상대방과 효과적으로 의지할 때 가장 독립적일 수 있다는 사실을 잊지 마세요.',
      '상대방과 관계에서 거리를 두고 싶은 욕구가 생기면, 관계를 부정적으로 만드는 말과 행동 대신 이에 대해 솔직하고 효과적으로 소통하는 것이 좋습니다.',
      '만나지도 않은 운명의 상대를 꿈꾸기보다, 눈앞의 상대방이 나에게 얼마나 소중한지, 장점이 많은 사람인지에 집중해보세요.',
    ],
    dealing: [
      '회피형 상대방은 적당한 거리가 필요한 성향이라는 것을 이해하는게 필요합니다.',
      '회피형 상대방이 거리를 두려고 한다면, 힘들더라도 따라가지 않는 것이 좋습니다. 거리를 두는 상대를 잡아두려고 할 수록 더 큰 위협을 주게 됩니다.',
      '모든 것을 상대방과 함께하려고 하거나, 내 감정을 상대방에게 의지하기 보다, 스스로 중심을 유지하는 것이 좋습니다.',
    ],
  },
  ANXIOUS: {
    general: [
      '상대방이 관심과 애정을 잃게 될까 봐 불안해하며, 애정과 사랑을 자주 확인하고자 하는 경향이 있습니다.',
      '다른 사람을 쉽게 과대평가하고, 쉽게 사랑에 빠지는 경향이 있습니다.',
      '상대방의 기분이나 행동에 민감하게 반응하여, 상대의 의도를 과도하게 부정적으로 해석하는 경우가 있습니다.',
      '상대방과 멀어졌다고 느끼면 상대방과 가까워지기 위해 ‘항의 행동’을 하곤 합니다.\n(마음에도 없는 이별 이야기하기, 질투심 유발하기, 무시하기, 받은만큼 돌려주기)',
    ],
    advice: [
      '친밀감에 대한 자신의 욕구와 감정을 솔직하게 인정하는 것이 필요합니다.',
      '상대방이 자신의 욕구를 알아주기를 바라기 보다는, 자신의 욕구에 대해 솔직하게 표현하고 효과적으로 의사소통 하는 것이 도움이 됩니다.',
      '나의 욕구와 감정을 이해하고 존중하는 상대방을 만나는게 좋습니다. (관계에 기복이 없어 좀 심심하다고 느끼더라도요)',
      '반대로 그것을 무시하거나 존중하지 않는 상대방과는 거리를 둘 필요가 있습니다.',
    ],
    dealing: [
      '불안형인 상대방은 친밀감과 안정감이 필요한 성향이라는 것을 이해하는게 필요합니다.',
      '관계에서 생기는 긍정적이고 부정적인 감정들을 솔직하고 효과적으로 의사소통하는 게 필요합니다.',
      '상대에게 모든 것을 맞춰주겠다는 자세는 좋지 않습니다. 나와 상대방의 선을 설정하고 일관되게 행동하며, 신뢰를 쌓아가는 것이 좋습니다.',
    ],
  },

  DISORGANIZED: {
    general: [
      '상대방과 가까워지길 원하고 친밀감을 원하면서도, 버림받을 수 있다는 걱정에 상대를 밀어내곤 합니다.',
      '상대에게 버림받지 않기 위해서, 내가 원하지 않거나 하기 싫은 행동이라도 하는 경우가 있습니다.',
      '상대방이 나를 버리지 않을 사람인지, 믿을 수 있는 사람인지 확인하기 위해 상대를 시험하기도 합니다.',
    ],
  },
}

export namespace AttachmentTypeData {
  export const getText = (type: AttachmentType) => {
    return AttachmentTypeDatas[type].text
  }

  export const getIcon = (type: AttachmentType) => {
    return AttachmentTypeDatas[type].icon
  }

  export const getColor = (type: AttachmentType) => {
    return AttachmentTypeDatas[type].color
  }

  export const getGraphImage = (type: AttachmentType) => {
    return AttachmentTypeDatas[type].graphImage
  }

  export const getDescriptions = (type: AttachmentType): AttachmentTypeDescription => {
    return AttachmentTypeDescriptions[type]
  }

  export const getDotEmoji = (type: AttachmentType) => {
    return AttachmentTypeDatas[type].dotEmoji
  }

  export const getGraphImage0to10 = (type: AttachmentType) => {
    return AttachmentTypeDatas[type].graphImage0to10
  }
}
